import React from "react"
import { Alert as AntdAlert } from "antd"
import type { AlertProps } from "antd/lib/alert"

export const Alert = (props: AlertProps): JSX.Element => {
  return <AntdAlert {...props} />
}
